import * as React from 'react';
import { PaperClipOutlined } from '@ant-design/icons';
import { withUserType } from '../withUserType';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getFileLink } from '../../utils/FileAccessUtils';

// Read-only list of the deliverable's document attachments ([{ fileId, fileName }]).
// Adding/removing happens in the create/edit form; here we just show + open them.
const DeliverableDocuments = ({ deliverable, userType }: any) => {
	const attachments = nullSafeGetOrElse('attachments', deliverable, []);

	return (
		<div>
			<div className="mb-2">
				<span className="h5medium text-character-primary">Documents ({attachments.length})</span>
			</div>
			{attachments.length ? (
				<div className="flex flex-col gap-1">
					{attachments.map((file) => (
						<a
							key={file.fileId}
							href={getFileLink(file.fileId, file.fileName, userType)}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 text-character-secondary hover:text-character-primary"
						>
							<PaperClipOutlined className="text-[12px]" />
							<span className="bodyregular">{file.fileName}</span>
						</a>
					))}
				</div>
			) : (
				<span className="footnoteregular text-character-disabled">No documents</span>
			)}
		</div>
	);
};

export default withUserType(DeliverableDocuments);
